// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__mLC1z","loader":"loader_loader__DK7CN"};